var map = {
	"./de-DE.json": 2273,
	"./en-US.json": 2274,
	"./es-MX.json": 2275,
	"./fr-FR.json": 2276,
	"./ja-JA.json": 2277,
	"./ko-KR.json": 2278,
	"./pt-BR.json": 2279,
	"./th-TH.json": 2280,
	"./zh-CN.json": 2281
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1186;